<template>
  <router-view :key="language" />
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'App',
  computed: {
    ...mapState(['language']),
  },
  watch: {
    language(newLang) {
      this.$i18n.locale = newLang
      document.documentElement.lang = newLang // Atualiza o atributo lang do HTML
    },
  },
  created() {
    this.$i18n.locale = this.language // Define o idioma inicial
    document.documentElement.lang = this.language // Define o idioma inicial no HTML
  },
}
</script>
